import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './pages/layout/admin/admin.component';
import { AuthComponent } from './pages/layout/auth/auth.component';
import { CleanComponent } from './pages/layout/clean/clean.component';
import { AuthGuard } from './guard/auth.guard.ts';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'registration',
        pathMatch: 'full'
      },
      {
        path: 'invitation',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/admin/invitation/invitation.module#InvitationModule'
      },
      {
        path: 'return-reasons',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/admin/return-reasons/return-reasons.module#ReturnReasonsModule'
      },
      {
        path: 'suitability',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/admin/suitability/suitability.module#SuitabilityModule'
      },
      {
        path: 'expiration',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/admin/expiration/expiration.module#ExpirationModule'
      },
      {
        path: 'registration',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/admin/registration/registration.module#RegistrationModule'
      },
      {
        path: 'diagnostics',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/admin/diagnostics/diagnostics.module#DiagnosticsModule'
      }
    ]
  },
  {
    path: '',
    component: CleanComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'company/:id',
            loadChildren: './pages/company/company.module#CompanyModule'
          },
          {
            path: 'person/:id',
            loadChildren: './pages/person/person.module#PersonModule'
          }
        ]
      },
      {
        path: 'invitation-auth/:id',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/multi-factor/invitation-auth/invitation-auth.module#InvitationAuthModule'
      },
      {
        path: 'invitation-token-check/:id/:method',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/multi-factor/invitation-token-check/invitation-token-check.module#InvitationTokenCheckModule'
      },
      {
        path: 'invitation-init/:id',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/multi-factor/invitation-init/invitation-init.module#InvitationInitModule'
      },
      {
        path: 'finished',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/finished/registration-finished.module#RegistrationFinishedModule'
      },
      {
        path: 'expired',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/expired/registration-expired.module#RegistrationExpiredModule'
      },
      {
        path: 'registration',
        redirectTo: 'admin',
        pathMatch: 'full'
      },
      {
        path: 'sign-adhesion-contract/:id',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/adhesion-contract/sign/sign-adhesion-contract.module#SignAdhesionContractModule'
      },
      {
        path: 'adhesion-contract-finish',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/adhesion-contract/finish/adhesion-contract-finish.module#AdhesionContractFinishModule'
      },
      {
        path: 'adhesion-contract-display/:id',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/adhesion-contract/display/display-adhesion-contract.module#DisplayAdhesionContractModule'
      },
      {
        path: 'sign-nonconformity-term/:id',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/nonconformity-term/sign/sign-nonconformity-term.module#SignNonconformityTermModule'
      },
      {
        path: 'nonconformity-term-display/:id',
        canActivate: [AuthGuard],
        loadChildren:
          './pages/nonconformity-term/display/display-nonconformity-term.module#DisplayNonconformityTermModule'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
